import type {
    AccountReconProductFeature,
    AchProductFeature,
    AgileticsWebEscrowProductFeature,
    BillPayProductFeature,
    ElectronicDocumentsProductFeature,
    ForeignCurrencyWireProductFeature,
    PositivePayProductFeature,
    RemoteDepositCaptureProductFeature,
    ReportingProductFeature,
    StopPaymentProductFeature,
    TransferProductFeature,
    WausauEStatementsProductFeature,
    WireProductFeature,
} from '../entities';
import { FeatureApiType } from './product-feature.enum';

export type SpecificCompanyProductFeature =
    | AccountReconProductFeature
    | AchProductFeature
    | AgileticsWebEscrowProductFeature
    | BillPayProductFeature
    | ElectronicDocumentsProductFeature
    | ForeignCurrencyWireProductFeature
    | PositivePayProductFeature
    | RemoteDepositCaptureProductFeature
    | ReportingProductFeature
    | StopPaymentProductFeature
    | TransferProductFeature
    | WausauEStatementsProductFeature
    | WireProductFeature;

export type FeatureMappingType = {
    [FeatureApiType.AccountRecon]: AccountReconProductFeature;
    [FeatureApiType.ACH]: AchProductFeature;
    [FeatureApiType.Agiletics]: AgileticsWebEscrowProductFeature;
    [FeatureApiType.BillPay]: BillPayProductFeature;
    [FeatureApiType.ElectronicDocuments]: ElectronicDocumentsProductFeature;
    [FeatureApiType.ForeignCurrencyWire]: ForeignCurrencyWireProductFeature;
    [FeatureApiType.PositivePay]: PositivePayProductFeature;
    [FeatureApiType.RemoteDeposit]: RemoteDepositCaptureProductFeature;
    [FeatureApiType.Reporting]: ReportingProductFeature;
    [FeatureApiType.StopPayment]: StopPaymentProductFeature;
    [FeatureApiType.Transfer]: TransferProductFeature;
    [FeatureApiType.Wausau]: WausauEStatementsProductFeature;
    [FeatureApiType.Wire]: WireProductFeature;
};
